/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { ProductHistoryDTOFromJSON, } from '../models/index';
/**
 *
 */
export class ProductHistoryControllerApi extends runtime.BaseAPI {
    /**
     */
    async getAllHistoryByInventoryIdRaw(requestParameters, initOverrides) {
        if (requestParameters['inventoryId'] == null) {
            throw new runtime.RequiredError('inventoryId', 'Required parameter "inventoryId" was null or undefined when calling getAllHistoryByInventoryId().');
        }
        if (requestParameters['asin'] == null) {
            throw new runtime.RequiredError('asin', 'Required parameter "asin" was null or undefined when calling getAllHistoryByInventoryId().');
        }
        const queryParameters = {};
        if (requestParameters['inventoryId'] != null) {
            queryParameters['inventoryId'] = requestParameters['inventoryId'];
        }
        if (requestParameters['asin'] != null) {
            queryParameters['asin'] = requestParameters['asin'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/history/inventory`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProductHistoryDTOFromJSON));
    }
    /**
     */
    async getAllHistoryByInventoryId(requestParameters, initOverrides) {
        const response = await this.getAllHistoryByInventoryIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
